import { Student } from "../UnitReport";
import Heading from "./Heading.tsx";

type StudentInfoType = {
  student: Student,
  background: string,
  bg: string,
  color: string
}

export default function StudentInfo({ student, background,bg,color }:StudentInfoType) {

   

    return (
      <div>
        <Heading label="THÔNG TIN HỌC SINH" background={background} />
     
        <div className="flex">
          <div
            className="flex-1"
            style={{ border: "1px black solid", borderTop: "none" }}
          >
            <DrawBox
              label="Họ và tên học sinh"
              content={student.name}
              background={background}
              bg={bg}
              color={color}
            />
            <DrawBox
              label="Tên lớp"
              content={student.class}
              background={background}
              bg={bg}
              color={color}
            />
            <DrawBox
              label="Giáo viên"
              content={student.teacher}
              background={background}
              bg={bg}
              color={color}
              last
            />
          </div>
          <div
            className="flex-1"
            style={{
              border: "1px black solid",
              borderLeft: "none",
              borderTop: "none",
            }}
          >
            <DrawBox
              label="Tên sách"
              content={student.syllabus}
              background={background}
              bg={bg}
              color={color}
            />
            <DrawBox
              label="Bài đánh gia Unit "
              content={`Unit ${student.unit}`}
              background={background}
              bg={bg}
              color={color}
            />
            <DrawBox
              label="Số buổi của lộ trình"
              content={`${student.courseCompleted.lessons} / ${student.courseCompleted.totalLessons}`}
              background={background}
              bg={bg}
              color={color}
              last
            />
          </div>
        </div>
      </div>
    );
}

type DrawBoxType = {
    label: string,
  content: string,
  background: string,
  bg: string,
  color:string
  last?: boolean,
}

function DrawBox({ label, content , background, bg, color, last }:DrawBoxType) {
    
    return (
      <div
        className="flex h-20"
        style={{ borderBottom: last ? "none" : "black 1px solid" }}
      >
        <div
          className="w-60 text-white"
          style={{
            background,
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            borderRight: "black 1px solid",
            textAlign:"center"
          }}
        >
          {label}
        </div>
        <div
          className="w-full"
          style={{
            background: bg,
            color,
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {content}
        </div>
      </div>
    );
}